export default __webpack_public_path__ + "static/media/mediaman.d0687fbf.svg";